import LocalizedStrings from "react-localization";
import { de } from "./de";

export const localize = new LocalizedStrings({
  de
});
